module.exports = __webpack_public_path__ + "img/web_1.2377b582.png";